import React from "react";
import { NavLink } from "react-router-dom";
import { Bus, GraduationCap } from "lucide-react";

/**
 * Shared sub-nav for the merged "Tournées" menu entry.
 * Allows operators to swap between GTFS bus trips and school transport routes
 * without losing the existing pages or URLs.
 */
export default function TourneesTabs() {
  const base = "px-4 py-2 text-xs font-bold uppercase tracking-widest inline-flex items-center gap-2 border border-zinc-900";
  return (
    <div className="inline-flex mb-5" data-testid="tournees-tabs">
      <NavLink to="/admin/gtfs-trips" end data-testid="tab-gtfs-trips"
        className={({ isActive }) => `${base} ${isActive ? "bg-zinc-900 text-[#FFC60A]" : "bg-white hover:bg-zinc-100"}`}>
        <Bus size={14} /> Tournées bus (GTFS)
      </NavLink>
      <NavLink to="/admin/routes" data-testid="tab-school-routes"
        className={({ isActive }) => `${base} border-l-0 ${isActive ? "bg-zinc-900 text-[#FFC60A]" : "bg-white hover:bg-zinc-100"}`}>
        <GraduationCap size={14} /> Tournées scolaires
      </NavLink>
    </div>
  );
}
